import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    aiButton: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '10px 20px',
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '14px',
        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
        transition: 'all 0.3s ease',
        '&:hover': {
            background: 'linear-gradient(135deg, #5568d3 0%, #6a3f91 100%)',
            boxShadow: '0 6px 20px rgba(102, 126, 234, 0.6)',
            transform: 'translateY(-2px)'
        },
        '&:disabled': {
            background: 'linear-gradient(135deg, #999 0%, #666 100%)',
            color: 'white',
            opacity: 0.7
        }
    },
    sparkleIcon: {
        fontSize: '20px',
        marginRight: '8px',
        display: 'inline-block',
        animation: '$sparkle 2s ease-in-out infinite',
    },
    '@keyframes sparkle': {
        '0%, 100%': { 
            opacity: 1, 
            transform: 'scale(1) rotate(0deg)' 
        },
        '50%': { 
            opacity: 0.7, 
            transform: 'scale(1.2) rotate(10deg)' 
        }
    }
}));

/**
 * AIButton - Composant bouton réutilisable avec style IA
 * 
 * @param {Object} props
 * @param {Function} props.onClick - Fonction appelée au clic
 * @param {boolean} props.loading - Affiche un loader
 * @param {boolean} props.disabled - Désactive le bouton
 * @param {string} props.children - Texte du bouton
 * @param {string} props.loadingText - Texte pendant le chargement
 * @param {Object} props.style - Styles additionnels
 */
const AIButton = ({ 
    onClick, 
    loading = false, 
    disabled = false, 
    children = "Action IA",
    loadingText = "Traitement...",
    style = {},
    ...otherProps 
}) => {
    const classes = useStyles();

    return (
        <Button
            className={classes.aiButton}
            onClick={onClick}
            disabled={disabled || loading}
            style={style}
            {...otherProps}
        >
            {loading ? (
                <>
                    <CircularProgress size={16} style={{ color: 'white', marginRight: '8px' }} />
                    {loadingText}
                </>
            ) : (
                <>
                    <span className={classes.sparkleIcon}>✨</span>
                    {children}
                </>
            )}
        </Button>
    );
};

export default AIButton;
